import { FunctionComponent, useEffect } from 'react'

type LoadCSSProps = {
  href: string
}
export const LoadCSS: FunctionComponent<LoadCSSProps> = ({href}) => {
  useEffect(() => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    document.head.appendChild(link)
    return () => {
      document.head.removeChild(link)
    }
  })
  return null
}